import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import PairBrowser from '@/components/PairBrowser'
import SpeciesGenusBrowser from '@/components/SpeciesGenusBrowser'
import ViewPair from '@/components/ViewPair'
import Data from '@/components/data'
Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/pairbrowser',
            name: 'PairBrowser',
            component: PairBrowser,
        },
        {
            path: '/speciesgenusbrowse',
            name: 'SpeciesGenusBrowser',
            component: SpeciesGenusBrowser,
        },
        {
            path:'/viewpair/:p/:humanrun/:mouserun',
            name:'ViewPair/:p/:humanrun/:mouserun',
            component: ViewPair,
            children:[
                {
                    path: '/viewpair/sp/:species',
                    name: 'ViewPair/sp/:species',
                    component: ViewPair,
                },
                {
                    path: '/viewpair/gen/:genus',
                    name: 'ViewPair/gen/:genus',
                    component: ViewPair,
                },
            ]
        },
        {
            path: '/data',
            name: 'Data',
            component: Data,
        },
    ]
})

export default router
